export interface CookieHandler {
  getCookie(cname: string): string;
  setCookie(cname: string, cvalue: string, expDays: number): void;
  deleteCookie(cname: string): void;
}

export const CookieHandlerInstance: CookieHandler = {
  getCookie(cname: string) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    let foundCookie;
    cookieArray.forEach((el) => {
      let c = el;
      while (c.startsWith(' ')) {
        c = c.substring(1);
      }
      if (c.startsWith(name)) {
        foundCookie = c.substring(name.length, c.length);
      }
    });
    return foundCookie ?? '';
  },
  setCookie(cname: string, cvalue: string, expDays: number) {
    const d = new Date();
    d.setTime(d.getTime() + (expDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${d.toUTCString()}`;
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
  },
  deleteCookie(cname: string) {
    const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
    document.cookie = `${cname}=;${expires};path=/`;
  },
};
